module.exports = __webpack_public_path__ + "media/images/emblems/Holderbank_SO-blason-94df2138d5ca914c2655eb4749023321.png";